// import { useState } from "react";

export const useLocalStorage = <T = string | number | Date | object>(
  name: string,
  defaultValue: T
): [T, (value: T) => void] => {
  // Create a variable to store the default value or stored value.
  let value: T = defaultValue;

  // Get the stored value if it exists.
  const storedValue = localStorage.getItem(name);

  // If storedValue exists, replace value with parsed value.
  if (storedValue) {
    value = JSON.parse(storedValue) as T;
  } else {
    localStorage.setItem(name, JSON.stringify(value));
  }

  // Method that sets the localStorage value and also updates the state.
  const setValue = (value: T) =>
    localStorage.setItem(name, JSON.stringify(value));

  // Return the value and SetValue method.
  return [value, setValue];
};
